import { render, staticRenderFns } from "./Scripts.vue?vue&type=template&id=060cd90a"
import script from "./Scripts.vue?vue&type=script&lang=js"
export * from "./Scripts.vue?vue&type=script&lang=js"
import style0 from "./Scripts.vue?vue&type=style&index=0&id=060cd90a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports